import React from "react";
import "./CompanyVideos.scss";
import ReactPlayer from "react-player";

const CompanyVideos = () => {
  return (
    <>
      <div className="company_videos">
        <div className="container">
          <div className="heading_box">Company Videos</div>

          <div className="row justify-content-center">
            <div className="col-lg-6 col-12">
              <div className="company_videos_content">
                <ReactPlayer
                  className=""
                  width="100%"
                  controls
                  url="https://youtu.be/SH1FnG49HOI"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyVideos;
